export const TopBarTranslationsDictionary =
{
    Cancel: "Cancel",
    Connection: "Connection",
    DebugMode: "Debug mode",
    Exit: "Exit",
    Notifications: "Notifications",
    User: "User"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in TopBarTranslationsDictionary) {
        r.push(TopBarTranslationsDictionary[prop]);
    }
    return r;
};

export const TopBarTranslations = getTranslations();